// @ts-check
import { TemplateRegistry } from './templateRegistry';
import { PRICES_MAP } from './prices';
import {
  QUIZ_CONFIG_V6,
  QUIZ_CONFIG_V6_1,
  QUIZ_CONFIG_V6_2,
  QUIZ_CONFIG_V6_3,
  QUIZ_CONFIG_V6_4,
} from './quizConfigV6';
import { TID } from './templateIds';

export const templatesRegistry = new TemplateRegistry();

const GA_IDS = ['G-9CVR83DRHR', 'G-LD1VS8C7W8'];

if (parseInt(process.env.REACT_APP_DEBUG) === 1) {
  // @ts-ignore — debug-only global
  window.tr = templatesRegistry;
}

const uiConfig = {
  paywallPage: {
    variant: 'default',
    BoxPrice: 'default',
    AchieveMassive: 'default',
    H1: 'default',
    DiscountHeader: 'hidden',
    DiscountTimerBlock: 'hidden',
    YourReadiness: 'hidden',
    PlanHint: 'hidden',
    paymentInPaywall: false,
    specialOffer: false,
  },
  quizPage: {
    quizWrapper: {
      quizProgressBar: 'default',
    },
    SelectButton: {
      immediateSelect: false,
    },
    AnalyzingPage: {
      showReviews: false,
    },
  },
  thanksPage: {
    MobilePlatformFlow: 'default',
    WebPlatformFlow: 'hidden',
  },
};

const defaultConfig = {
  dynamicPageVersion: 'v2',
  quizConfig: QUIZ_CONFIG_V6,
  routeAfterPaymentSuccess: '../upsells',
  routeAfterUpsellsSuccess: '../thanks-v2',
  priceVariants: [
    PRICES_MAP['699_7day-2999_1month_v2'],
    PRICES_MAP['1999_1month-2999_1month_v2'],
    PRICES_MAP['2999_3month-5499_3month_v2'],
  ],
  specialOfferPriceVariants: [
    PRICES_MAP['499_7day-2999_1month'],
    PRICES_MAP['1499_1month-2999_1month'],
    PRICES_MAP['1999_3month-5499_3month_v2'],
  ],
  payWallText: 'paywallPage.subscription_info',
  uiConfig: {
    ...uiConfig,
    paywallPage: {
      ...uiConfig.paywallPage,
      variant: 'paywall-5',
      BoxPrice: 'price_per_day_violet_detailed',
      paymentInPaywall: true,
      specialOffer: true,
      defaultPriceVariantIndex: 0,
      detailedIndex: 0,
      mostPopularIndex: 0,
    },
    paymentPage: {
      variant: 'payment-page-1',
    },
  },
  enableFbPixel: true,
  enableTiktokAnalytics: false,
  enableGoogleAnalytics: true,
  enableAxonPixel: false,
  fbPixelId: '906797097343491',
  tiktokPixelId: 'CSK9563C77UA15LGBS1G',
  gaTrackingId: GA_IDS[0],
  axonEventKey: 'eb896821-cebe-4a43-aa5b-6a2b2c85452e',
};

templatesRegistry.register(TID.DEFAULT, defaultConfig);

templatesRegistry.register(TID.LETTERS, {
  ...defaultConfig,
  priceVariants: [PRICES_MAP['0-2999_6month']],
  routeAfterUpsellsSuccess: '../thanks',
  uiConfig: {
    ...uiConfig,
    paywallPage: uiConfig.paywallPage,
  },
});

templatesRegistry.register(
  TID.A,
  {
    uiConfig: {
      paywallPage: {
        variant: 'paywall-6',
      },
      paymentPage: {
        variant: 'payment-page-2',
      },
    },
  },
  TID.DEFAULT
);

// 005 family

templatesRegistry.register(
  TID.F005AA,
  {
    uiConfig: {
      paywallPage: {
        BoxPrice: 'price_per_day_violet',
      },
    },
  },
  TID.DEFAULT
);

templatesRegistry.register(
  TID.T005AA,
  { enableTiktokAnalytics: true },
  TID.F005AA
);

templatesRegistry.register(
  TID.F005AB,
  { quizConfig: QUIZ_CONFIG_V6_1 },
  TID.F005AA
);
templatesRegistry.register(
  TID.T005AB,
  { enableTiktokAnalytics: true },
  TID.F005AB
);

templatesRegistry.register(
  TID.F005AC,
  { quizConfig: QUIZ_CONFIG_V6_2 },
  TID.F005AA
);
templatesRegistry.register(
  TID.T005AC,
  { enableTiktokAnalytics: true },
  TID.F005AC
);

templatesRegistry.register(
  TID.F005AD,
  { quizConfig: QUIZ_CONFIG_V6_3 },
  TID.F005AA
);
templatesRegistry.register(
  TID.T005AD,
  { enableTiktokAnalytics: true },
  TID.F005AD
);

templatesRegistry.register(
  TID.F005AE,
  { quizConfig: QUIZ_CONFIG_V6_4 },
  TID.F005AA
);
templatesRegistry.register(
  TID.T005AE,
  { enableTiktokAnalytics: true },
  TID.F005AE
);

templatesRegistry.register(
  TID.F005RR,
  {
    getTemplateIdForABTest: () => {
      const targets = [
        TID.F005AA,
        TID.F005AB,
        TID.F005AC,
        TID.F005AD,
        TID.F005AE,
      ];
      return targets[Math.floor(Math.random() * targets.length)];
    },
  },
  TID.F005AA
);
templatesRegistry.register(
  TID.T005RR,
  {
    getTemplateIdForABTest: () => {
      const targets = [
        TID.T005AA,
        TID.T005AB,
        TID.T005AC,
        TID.T005AD,
        TID.T005AE,
      ];
      return targets[Math.floor(Math.random() * targets.length)];
    },
  },
  TID.T005AA
);

// 006 family

templatesRegistry.register(
  TID.F006AA,
  {
    uiConfig: {
      paywallPage: {
        variant: 'paywall-6',
        BoxPrice: 'price_per_day_violet',
      },
      paymentPage: {
        variant: 'payment-page-3',
      },
    },
  },
  TID.F005AA
);

templatesRegistry.register(
  TID.T006AA,
  { enableTiktokAnalytics: true },
  TID.F006AA
);

templatesRegistry.register(
  TID.F006AB,
  { quizConfig: QUIZ_CONFIG_V6_1 },
  TID.F006AA
);
templatesRegistry.register(
  TID.T006AB,
  { enableTiktokAnalytics: true },
  TID.F006AB
);

templatesRegistry.register(
  TID.F006AC,
  { quizConfig: QUIZ_CONFIG_V6_2 },
  TID.F006AA
);
templatesRegistry.register(
  TID.T006AC,
  { enableTiktokAnalytics: true },
  TID.F006AC
);

templatesRegistry.register(
  TID.F006AD,
  { quizConfig: QUIZ_CONFIG_V6_3 },
  TID.F006AA
);
templatesRegistry.register(
  TID.T006AD,
  { enableTiktokAnalytics: true },
  TID.F006AD
);

templatesRegistry.register(
  TID.F006AE,
  { quizConfig: QUIZ_CONFIG_V6_4 },
  TID.F006AA
);
templatesRegistry.register(
  TID.T006AE,
  { enableTiktokAnalytics: true },
  TID.F006AE
);

templatesRegistry.register(
  TID.F006RR,
  {
    getTemplateIdForABTest: () => {
      const targets = [
        TID.F006AA,
        TID.F006AB,
        TID.F006AC,
        TID.F006AD,
        TID.F006AE,
      ];
      return targets[Math.floor(Math.random() * targets.length)];
    },
  },
  TID.F006AA
);
templatesRegistry.register(
  TID.T006RR,
  {
    getTemplateIdForABTest: () => {
      const targets = [
        TID.T006AA,
        TID.T006AB,
        TID.T006AC,
        TID.T006AD,
        TID.T006AE,
      ];
      return targets[Math.floor(Math.random() * targets.length)];
    },
  },
  TID.T006AA
);

// letters

templatesRegistry.register(
  TID._99999,
  {
    priceVariants: [PRICES_MAP['0-2999_6month']],
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 7 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 month until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._1,
  {
    templateId: TID._3,
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 7 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 month until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_7day-2999_1month']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._2,
  {
    templateId: TID._4,
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_14day-2999_3month']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._3,
  {
    templateId: TID._5,
    priceVariants: [PRICES_MAP['0_14day-2999_3month']],
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._4,
  {
    templateId: TID._6,
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 7 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 month until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_7day-2999_1month']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._5,
  {
    templateId: TID._7,
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_14day-2999_3month']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._6,
  {
    templateId: TID._8,
    priceVariants: [PRICES_MAP['0_14day-2999_3month']],
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._7,
  {
    templateId: TID._9,
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $89.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_14day-8999_1year']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._8,
  {
    templateId: '10',
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $89.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_14day-8999_1year']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._9,
  {
    templateId: TID._11,
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 1 month free introductory offer, you will automatically be charged the full price of the subscription at $89.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_1month-8999_1year']],
  },
  TID.LETTERS
);

templatesRegistry.register(
  TID._11,
  {
    templateId: '13',
    payWallText:
      "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 1 month free introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
    priceVariants: [PRICES_MAP['0_1month-2999_1year']],
  },
  TID.LETTERS
);
